import React, { Component } from 'react';
import Billing from '../../components/developers/billing'
// const enc = API.encrypt
export default class billing extends Component {
  componentDidMount(){
// document.getElementById('main').style.backgroundColor='#f9f9f9'
  }
    render() {
       
        return (
          <div id='SmartAPI-loader'>
          <Billing/>
          </div>
        );
    }
}
